/*!
 * devextreme-angular
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input,
    ContentChildren,
    forwardRef,
    QueryList
} from '@angular/core';




import DevExpress from 'devextreme/bundles/dx.all';
import { DiagramCommand, DiagramShapeCategory, DiagramShapeType, DiagramToolboxDisplayMode } from 'devextreme/ui/diagram';

import {
    NestedOptionHost,
} from 'devextreme-angular/core';
import { CollectionNestedOption } from 'devextreme-angular/core';
import { DxiCommandComponent } from './command-dxi';


@Component({
    selector: 'dxi-group',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxiGroupComponent extends CollectionNestedOption {
    @Input()
    get commands(): Array<DiagramCommand | DevExpress.ui.dxDiagramCustomCommand> {
        return this._getOption('commands');
    }
    set commands(value: Array<DiagramCommand | DevExpress.ui.dxDiagramCustomCommand>) {
        this._setOption('commands', value);
    }

    @Input()
    get title(): string {
        return this._getOption('title');
    }
    set title(value: string) {
        this._setOption('title', value);
    }

    @Input()
    get category(): DiagramShapeCategory | string {
        return this._getOption('category');
    }
    set category(value: DiagramShapeCategory | string) {
        this._setOption('category', value);
    }

    @Input()
    get displayMode(): DiagramToolboxDisplayMode {
        return this._getOption('displayMode');
    }
    set displayMode(value: DiagramToolboxDisplayMode) {
        this._setOption('displayMode', value);
    }

    @Input()
    get expanded(): boolean {
        return this._getOption('expanded');
    }
    set expanded(value: boolean) {
        this._setOption('expanded', value);
    }

    @Input()
    get shapes(): Array<DiagramShapeType | string> {
        return this._getOption('shapes');
    }
    set shapes(value: Array<DiagramShapeType | string>) {
        this._setOption('shapes', value);
    }


    protected get _optionPath() {
        return 'groups';
    }


    @ContentChildren(forwardRef(() => DxiCommandComponent))
    get commandsChildren(): QueryList<DxiCommandComponent> {
        return this._getOption('commands');
    }
    set commandsChildren(value) {
        this.setChildren('commands', value);
    }

    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }



    ngOnDestroy() {
        this._deleteRemovedOptions(this._fullOptionPath());
    }

}

@NgModule({
  declarations: [
    DxiGroupComponent
  ],
  exports: [
    DxiGroupComponent
  ],
})
export class DxiGroupModule { }
